var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"centered-text-hr clearfix",class:_vm.containerClass},[_c('hr',{staticClass:"my-0"}),_c('p',{staticClass:"mb-0 text-center t-600 t-sm"},[_vm._v(" OR ")]),_c('hr',{staticClass:"my-0"})])}
var staticRenderFns = []

export { render, staticRenderFns }